import type { FaireProductEntity } from "../../entity_types/product";

export const p_f727ru8d46: FaireProductEntity = {
  token: "p_f727ru8d46",
  type: "product",
  name: "Ponderosa Pine - 6 oz Black Matte Candle Tin",
  brandName: "Pine and Sage Candles",
  imageUrl:
    "https://cdn.faire.com/fastly/59db1802dd325483e28be2a9124f1e8364e1b32cd354a4ff1ff7571314629086.png",
  priceDollars: 4,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/09046ce1de50a75f0031e8963765ece550f82bc59a1171ac030d2e01ddbd4edb.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
